import {
  searchByName,
  getPage,
  getDetail,
} from '@/api/clientserv'

export default {
  state: {
    state_Client_SearchByNameResult: null,
    state_Client_GetPageResult: null,
    state_Client_GetDetailResult: null,
  },
  mutations: {
    SET_CLIENT_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_Client_SearchByNameResult = rst;
    },
    SET_CLIENT_GETPAGE_RESULT: (state, rst) => {
      state.state_Client_GetPageResult = rst;
    },
    SET_CLIENT_GETDETAIL_RESULT: (state, rst) => {
      state.state_Client_GetDetailResult = rst;
    },
  },
  actions: {
    ClientServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CLIENT_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CLIENT_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ClientServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CLIENT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CLIENT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ClientServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CLIENT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CLIENT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_Client_SearchByNameResult: state => {
      return state.state_Client_SearchByNameResult;
    },
    get_Client_GetPageResult: state => {
      return state.state_Client_GetPageResult;
    },
    get_Client_GetDetailResult: state => {
      return state.state_Client_GetDetailResult;
    },
  }
}